// extracted by mini-css-extract-plugin
export var carrierIcon = "_ti-0";
export var carrierLogo = "_ti-1";
export var detailsSection = "_ti-2";